import {createContext} from 'react';

export const AccContext = createContext(null);